import styled from 'styled-components';
import { COLORS } from '../../constants/theme';

export { CardSection, SectionDivider, SectionHeader, IconBadge } from '../../components/styles/FormCard.styles';

export const CompanyHeader = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
	margin-bottom: 16px;
`;

export const CompanyDivider = styled.div`
	width: 1px;
	height: 32px;
	background: ${COLORS.light.medium};
	flex-shrink: 0;
`;

export const AlertBox = styled.div`
	.doca-alert {
		text-align: left;
	}

	.doca-alert__text {
		text-align: left;
		white-space: normal;
		overflow: visible;
		text-overflow: unset;
	}
`;

export const FieldRow = styled.div`
	display: flex;
	flex-direction: row;
	gap: 12px;

	> * {
		flex: 1;
		min-width: 0;
	}
`;
